<template>
  <div class="boogo-view" v-if="!userHasSubscription && isBooGoPromoActive">
    <div class="boogo-view__individuals">
      <div class="boogo-view__plan-card">
        <PlanRowItem :key="booGoPlan.id" :plan="booGoPlan" class="plan-list-item-row__boogo-card" />
        <div class="boogo-view__small-prints--desktop">
          <SmallPrints />
        </div>
      </div>
      <div class="boogo-view__description">
        <div class="boogo-view__description-title">BooGo is Back!</div>
        <div class="boogo-view__description-first-paragraph">Save for a limited time only.</div>
        <div class="boogo-view__description-second-paragraph">
          From now through October 31, 2024, you can get 2 years of INE Premium for only $999.
          You’ll also receive one 50% off coupon for an INE Security certification voucher at the
          time of purchase, and another at the start of year two!
        </div>
        <div class="boogo-view__description-title--small">Why INE Premium?</div>
        <div class="boogo-view__description-third-paragraph">
          INE Premium delivers professional and expert-level, hands-on technology training across
          Networking, Cybersecurity, and Cloud! The content in this subscription plan is
          specifically designed to empower technologists at every stage of their learning journey,
          including:
          <ul>
            <li>Technologists interested in upskilling or reskilling to enhance their career</li>
            <li>
              IT/Cybersecurity professionals wanting to sharpen their skills through in-depth
              training
            </li>
            <li>
              Any technologists prepping for industry certifications at the professional level or
              higher
            </li>
          </ul>

          What you get with INE Premium
          <ul>
            <li>
              Dozens of immersive Learning Paths and courses across Networking, Cybersecurity, and
              Cloud
            </li>
            <li>
              Extensive, in-depth certification prep for certifications from industry leaders like
              Cisco, AWS, and more
            </li>
            <li>Expert-led videos, quizzes, hands-on labs, and practice exams</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="boogo-view__small-prints--mobile">
      <SmallPrints />
    </div>
    <div class="boogo-view__teams">
      <div class="boogo-view__teams-title">Interested in BooGo discounts for your team?</div>
      <div class="boogo-view__teams-lets-talk">
        <a target="_blank" :href="letsTalkLink" class="boogo-view__teams-lets-talk-link">
          Let's talk
        </a>
        about how you can save big on your team's training needs.
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import PlanRowItem from '@/components/plan-item-card/PlanRowItem.vue'
import SmallPrints from '@/components/flow/small-prints/SmallPrints.vue'
import CONSTANTS from '@/constants'
import { updateCart, utmParamsUtils } from '@/helpers/mixins'

export default {
  name: 'BooGoView',
  mixins: [updateCart, utmParamsUtils],
  components: {
    PlanRowItem,
    SmallPrints,
  },
  computed: {
    ...mapState({
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
    }),
    ...mapGetters({
      plans: 'products/plansByTerm',
      isBooGoPromoActive: 'app/getIsBooGoPromoActive',
    }),
    userHasSubscription() {
      return this.usersCurrentSubscriptions.length > 0
    },
    booGoPlan() {
      return this.plans.yearly.find(
        plan => plan.merchant_id === CONSTANTS.PLANS.INE_PREMIUM_BOOGO_2Y
      )
    },
    letsTalkLink() {
      const UTMParamsString =
        this.setUTMParamsString() === '' ? '' : `?${this.setUTMParamsString()}`
      return `https://engage.b.ine.com/B2B-Contact-Us.html${UTMParamsString}`
    },
  },
  created() {
    if (this.userHasSubscription || !this.isBooGoPromoActive) {
      this.$router.push({ name: 'shop' })
    } else {
      this.shoppingCart.forEach(item => this.removeProductFromShoppingCart(item))
      this.updateSelectedPlan(this.booGoPlan)
    }
  },
}
</script>
<style lang="scss">
.boogo-view {
  color: var(--white);
  background-color: var(--dark-brighter);
  font-family: var(--font-regular);
  padding: 20px;
  padding-top: 50px;
  display: flex;
  flex-flow: column;
  @include mobile {
    padding-top: 20px;
  }
  @include desktop {
    background-color: unset;
    max-width: 1120px;
    margin: auto;
    margin-top: 40px;
    position: relative;
    top: -7em;
  }
  &__individuals {
    @include mobile {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 20px;
    }
    @include desktop {
      column-gap: 60px;
    }
  }
  &__plan-card {
    @include mobile {
      grid-area: 1/2/2/3;
    }
  }
  &__description {
    &-title {
      font-family: var(--font-bold);
      font-style: normal;
      font-weight: 700;
      font-size: rem(32px);
      line-height: rem(38px);
      margin-bottom: 30px;
      @include desktop {
        font-size: rem(40px);
        line-height: rem(52px);
      }
      &--small {
        font-size: rem(24px);
        font-style: normal;
        font-weight: 700;
        line-height: rem(32px);
        padding: 20px 0;
      }
    }
    &-first-paragraph {
      font-style: normal;
      font-weight: 500;
      font-size: rem(18px);
      line-height: rem(24px);
      margin-bottom: 20px;
      @include desktop {
        font-size: rem(24px);
        line-height: rem(32px);
      }
    }
    &-second-paragraph {
      font-size: rem(16px);
      line-height: rem(24px);
    }
    &-third-paragraph {
      font-size: rem(14px);
      line-height: rem(20px);
    }
  }
  &__teams {
    display: flex;
    flex-flow: column;
    gap: 10px;
    padding: 40px;
    @include mobile {
      padding: 100px 40px;
    }
    &-title {
      font-family: var(--font-bold);
      text-align: center;
      font-style: normal;
      font-weight: 700;
      font-size: rem(20px);
      line-height: rem(26px);
      @include mobile {
        font-size: rem(24px);
        line-height: rem(32px);
      }
      @include tablet {
        font-size: rem(32px);
        line-height: rem(38px);
      }
    }
    &-lets-talk {
      color: var(--light-blue-gray);
      font-style: normal;
      font-weight: 500;
      font-size: rem(16px);
      line-height: rem(24px);
      text-align: center;
      @include mobile {
        font-size: rem(18px);
        line-height: rem(24px);
      }
      &-link {
        color: var(--purple-pale);
        font-size: rem(16px);
        line-height: rem(24px);
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
        @include mobile {
          font-size: rem(18px);
          line-height: rem(24px);
        }
      }
    }
  }
  &__small-prints {
    &--desktop {
      display: none;
      @include mobile {
        display: block;
      }
    }
    &--mobile {
      display: block;
      @include mobile {
        display: none;
      }
    }
  }
}
</style>
